// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-1MuAd","title":"title-p68wk"};